import Swal from 'sweetalert2';

/** Confirmación previa a eliminar. Devuelve Promise<boolean>. */
export const confirmDelete = async ({
  title = 'Eliminar registro',
  text = 'Esta acción no se puede deshacer.',
  confirmText = 'Eliminar',
} = {}) => {
  const result = await Swal.fire({
    icon: 'warning',
    title,
    text,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: 'Cancelar',
  });
  return !!result.isConfirmed;
};

/** Muestra un DomainError (o cualquier error) en Swal. */
export const showError = error => {
  const messages =
    error && Array.isArray(error.messages) && error.messages.length ? error.messages : [(error && error.message) || 'Ocurrió un error'];
  return Swal.fire({ icon: 'error', title: '', html: messages.map(m => `<div>${escapeHtml(m)}</div>`).join('') });
};

/** Aviso informativo (tono calmado, sin ícono de error). Mismo formato que showError. */
export const showAviso = error => {
  const messages = error && Array.isArray(error.messages) && error.messages.length ? error.messages : [(error && error.message) || ''];
  return Swal.fire({ icon: 'info', title: '', html: messages.map(m => `<div>${escapeHtml(m)}</div>`).join('') });
};

export const showSuccess = message => Swal.fire({ icon: 'success', title: '', text: message, timer: 2000, showConfirmButton: false });

const escapeHtml = text =>
  String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
